(function () {
  const SECTION_SELECTOR = '#shopify-section-template--25798343033174__custom_video_carousel_Tn4bbB';
  const SLIDE_SELECTOR = '.image-slide';
  const ICON_SELECTOR = '.mutedButton .musicIcon';

  function updateMusicIcons(root) {
    if (!root) return;
    // Always hide on original slide index 0; show on others
    root.querySelectorAll(SLIDE_SELECTOR).forEach(slide => {
      const origIndex = slide.getAttribute('data-slide-index'); // stable index even with clones
      slide.querySelectorAll(ICON_SELECTOR).forEach(icon => {
        icon.style.display = (origIndex === '0') ? 'none' : '';
      });
    });
  }

  function init() {
    const section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    // Initial pass
    updateMusicIcons(section);

    // If jQuery + Slick present, hook into events for resilience
    if (window.jQuery && jQuery(section).length) {
      const $main = jQuery(section).find('.main-image-slider');
      if ($main.length && typeof $main.on === 'function') {
        $main.on('init reInit afterChange setPosition', function () {
          updateMusicIcons(section);
        });
      }
    }

    // Fallback: observe DOM changes (e.g., when Slick adds/removes/clones)
    const mo = new MutationObserver(() => updateMusicIcons(section));
    mo.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
